export const TEMPERATURAOGRANICENA_V1ResourcesEN: TEMPERATURAOGRANICENA_V1ResourcesBSInterface =
  {
    labelDone: "Task completion date",
    errorMissingInput: "Please fill in all fields",
    input: {
      signatureTitle: "Signature",
      checkbox: {
        label:
          "I confirm that I have been notified that the temperature is not appropriate",
        name: "checkbox",
        placeholder: "You must accept this field",
      },
      datum: {
        label: "Please enter date",
        placeholder: "Please enter date",
        name: "datum",
      },
      ocitanaTemperatura: {
        label: "Read temperature",
        name: "ocitanaTemperatura",
        placeholder: "Please enter read temperature",
      },
      napomena: {
        label: "Note",
        name: "napomena",
        placeholder: "Please enter note",
      },
    },
    evidencijaForm: {
      buttonForward: "Sign",
      buttonBack: "Back",
    },
    successModal: {
      title: "Data Entry",
      body: "Data addition has been successfully completed. Select OK to continue.",
      buttonOk: "OK",
    },
    txtPotvrda:
      "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
  };

interface InputField {
  label: string;
  name: string;
  placeholder?: string;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  ocitanaTemperatura: InputField;
  napomena: InputField;
  checkbox: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

export interface TEMPERATURAOGRANICENA_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
}
